import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { isNil } from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import moment from "moment";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  Divider,
  Tab,
  Tabs,
  Paper,
  Box,
  Tooltip,
  Typography,
  Popover,
  Chip,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import QueueSelect from "../QueueSelect";
import TabPanel from "../TabPanel";
import { Autorenew, FileCopy } from "@material-ui/icons";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import SchedulesForm from "../SchedulesForm";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Colorize } from "@material-ui/icons";
import ColorPicker from "../ColorPicker";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import getRandomHexColor from "../../utils/getRandomHexColor";
import { getBackendUrl } from "../../config";
import { getWebChatPwaBaseUrl } from "../../helpers/webchatPwaUrl";
import whatsmeowIcon from "../../assets/whatsmeow.png";
import wahaIcon from "../../assets/waha-icon.png";
import evolutionIcon from "../../assets/evolution-icon.png";
import GreetingMediaAttachmentPreview from "../GreetingMediaAttachmentPreview";
import WebchatConnectionSwitch from "../WebchatConnectionSwitch";
import {
  getGreetingMediaPublicUrl,
  revokeObjectUrlIfBlob,
} from "../../utils/greetingMediaAttachmentUrl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },

  multFieldLine: {
    marginTop: 12,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: "relative",
  },
  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 3,
    padding: 12,
    border: "solid grey 2px",
    borderRadius: 4,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  tokenRefresh: {
    minWidth: "auto",
    display: "flex", // Torna o botão flexível para alinhar o conteúdo
    alignItems: "center", // Alinha verticalmente ao centro
    justifyContent: "center", // Alinha horizontalmente ao centro
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
  formControl: {
    width: 220,
    // paddingTop: 14
  },
  colorField: {
    width: 150,
  },
}));

const SessionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

const MIN_EXPIRES_TICKET_MINUTES = 5;
const MIN_INACTIVE_WARNING_MINUTES = 5;

const WhatsAppModal = ({ open, onClose, whatsAppId, channel }) => {
  const classes = useStyles();
  const [autoToken, setAutoToken] = useState("");

  // Debug: verificar channel
  useEffect(() => {
    if (open) {
      console.log("[DEBUG WhatsAppModal] Channel recebido:", channel);
    }
  }, [open, channel]);

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");
  const [attachmentPreviewUrl, setAttachmentPreviewUrl] = useState("");

  const initialState = {
    name: "",
    greetingMessage: "",
    complationMessage: "",
    outOfHoursMessage: "",
    ratingMessage: "",
    isDefault: false,
    token: "",
    maxUseBotQueues: 3,
    provider: "beta",
    expiresTicket: 0,
    allowGroup: false,
    inboundOnly: false,
    enableImportMessage: false,
    groupAsTicket: "disabled",
    timeUseBotQueues: "0",
    timeSendQueue: "0",
    sendIdQueue: 0,
    expiresTicketNPS: "0",
    expiresInactiveMessage: "",
    timeInactiveMessage: "",
    inactiveMessage: "",
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: "",
    importRecentMessages: "",
    importOldMessages: "",
    importOldMessagesGroups: "",
    integrationId: "",
    collectiveVacationEnd: "",
    collectiveVacationStart: "",
    collectiveVacationMessage: "",
    queueIdImportMessages: null,
    isOficial: false,
    phone_number_id: "",
    waba_id: "",
    send_token: "",
    business_id: "",
    phone_number: "",
    color: getRandomHexColor(),
    flowInactiveTime: 0,
    flowIdInactiveTime: 0,
    timeAwaitActiveFlowId: 0,
    maxUseInactiveTime: 1,
    timeToReturnQueue: 0,
    triggerIntegrationOnClose: true,
    triggerIntegrationOnCloseMode: "ask",
    wavoip: "",
    whatsappPin: "",
    enableWhatsappPin: false,
    secondaryConnection: false,
    webchatEnabled: false,
    rejectCalls: "disabled",
    rejectCallMessage: "",
  };
  const [whatsApp, setWhatsApp] = useState(initialState);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  // Gallera Voz: quem recebe as ligações desta conexão (vazio = todos)
  const [voiceRingUserIds, setVoiceRingUserIds] = useState([]);
  // Gallera Voz: token da conexão (vínculo com o painel de voz .254; estilo Wavoip)
  const [voiceToken, setVoiceToken] = useState("");
  const [companyUsers, setCompanyUsers] = useState([]);
  const [tab, setTab] = useState("general");
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] =
    useState(false);
  const [importOldMessages, setImportOldMessages] = useState(
    moment().add(-1, "days").format("YYYY-MM-DDTHH:mm")
  );
  const [importRecentMessages, setImportRecentMessages] = useState(
    moment().add(-1, "minutes").format("YYYY-MM-DDTHH:mm")
  );
  const [copied, setCopied] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [NPSEnabled, setNPSEnabled] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { user } = useContext(AuthContext);
  const [isOficial, setIsOficial] = useState(false);
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);

  const [schedules, setSchedules] = useState([
    {
      weekday: i18n.t("queueModal.serviceHours.monday"),
      weekdayEn: "monday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.tuesday"),
      weekdayEn: "tuesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.wednesday"),
      weekdayEn: "wednesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.thursday"),
      weekdayEn: "thursday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.friday"),
      weekdayEn: "friday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Sábado",
      weekdayEn: "saturday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Domingo",
      weekdayEn: "sunday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
  ]);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();

  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [triggerIntegrationOnClose, setTriggerIntegrationOnClose] =
    useState(true);
  const [triggerIntegrationOnCloseMode, setTriggerIntegrationOnCloseMode] =
    useState("ask");
  const [integrationType, setIntegrationType] = useState("n8n");
  const [integrationTypeId, setIntegrationTypeId] = useState(null);

  const [prompts, setPrompts] = useState([]);

  const [webhooks, setWebhooks] = useState([]);
  const [flowIdNotPhrase, setFlowIdNotPhrase] = useState();
  const [flowIdWelcome, setFlowIdWelcome] = useState();
  const [flowIdInactiveTime, setFlowIdInactiveTime] = useState();
  const [timeAwaitActiveFlowId, setTimeAwaitActiveFlowId] = useState();
  const [showWavoipCall, setShowWavoipCall] = useState(false);
  const [helpAnchorEl, setHelpAnchorEl] = useState(null);
  const [inactiveHelpAnchorEl, setInactiveHelpAnchorEl] = useState(null);
  const [chatBotType, setChatBotType] = useState("text");

  const handleHelpClick = (event) => {
    setHelpAnchorEl(event.currentTarget);
  };

  const handleHelpClose = () => {
    setHelpAnchorEl(null);
  };

  const handleInactiveHelpClick = (event) => {
    setInactiveHelpAnchorEl(event.currentTarget);
  };

  const handleInactiveHelpClose = () => {
    setInactiveHelpAnchorEl(null);
  };

  const helpOpen = Boolean(helpAnchorEl);
  const inactiveHelpOpen = Boolean(inactiveHelpAnchorEl);
  const renderInactiveHelpLabel = (labelText) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {labelText}{" "}
      <span
        onClick={handleInactiveHelpClick}
        style={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: "1.5px solid #d32f2f",
          color: "#d32f2f",
          fontWeight: 700,
          fontSize: 12,
          lineHeight: "18px",
          textAlign: "center",
          display: "inline-block",
          cursor: "pointer",
          userSelect: "none"
        }}
      >
        ?
      </span>
    </span>
  );

  useEffect(() => {
    if (!whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else if (whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else {
      setAutoToken(whatsApp.token);
    }
  }, [whatsAppId, whatsApp.token]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setUseWhatsappOfficial(planConfigs.plan.useWhatsappOfficial);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/prompt");
        setPrompts(data.prompts);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [whatsAppId]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/flowbuilder");
        setWebhooks(data.flows);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const settingSchedules = await getSetting({
        column: "scheduleType",
      });
      setSchedulesEnabled(settingSchedules.scheduleType === "connection");
      const settingNPS = await getSetting({
        column: "userRating",
      });
      setNPSEnabled(settingNPS.userRating === "enabled");
      try {
        const settingChatBot = await getSetting({
          column: "chatBotType",
        });
        if (settingChatBot?.chatBotType) {
          setChatBotType(settingChatBot.chatBotType);
        }
      } catch (err) {
        // se der erro, mantém "text"
      }
    };
    fetchData();
  }, []);

  const handleEnableImportMessage = async (e) => {
    setEnableImportMessage(e.target.checked);
  };

  const handleEnableIsOficial = async (e) => {
    setIsOficial(e.target.checked);
  };

  useEffect(() => {
    // Gallera Voz: carrega os usuários da empresa p/ o seletor "quem recebe ligações"
    const fetchCompanyUsers = async () => {
      try {
        const { data } = await api.get("/users/list");
        setCompanyUsers(Array.isArray(data) ? data : data?.users || []);
      } catch (_) {
        /* sem lista = seletor fica vazio, sem quebrar o modal */
      }
    };
    fetchCompanyUsers();
  }, []);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`whatsapp/${whatsAppId}?session=0`);

        if (data && data?.flowIdNotPhrase) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdNotPhrase}`
          );
          const selectedFlowIdNotPhrase = flowDefault?.flow.id;
          setFlowIdNotPhrase(selectedFlowIdNotPhrase);
        }

        if (data && data?.flowIdWelcome) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdWelcome}`
          );
          const selectedFlowIdWelcome = flowDefault?.flow.id;
          setFlowIdWelcome(selectedFlowIdWelcome);
        }

        if (data && data?.flowIdInactiveTime) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdInactiveTime}`
          );
          const selectedFlowIdInactiveTime = flowDefault?.flow.id;
          setFlowIdInactiveTime(selectedFlowIdInactiveTime);
        }

        if (data && data?.timeAwaitActiveFlowId) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.timeAwaitActiveFlowId}`
          );
          const selectedTimeAwaitActiveFlowId = flowDefault?.flow.id;
          setTimeAwaitActiveFlowId(selectedTimeAwaitActiveFlowId);
        }

        setWhatsApp({
          ...initialState,
          ...data,
          enableWhatsappPin: data.enableWhatsappPin || false,
          whatsappPin: data.whatsappPin || "",
          secondaryConnection: data.secondaryConnection || false,
          webchatEnabled: data.webchatEnabled === true,
          inboundOnly: data.inboundOnly === true,
        });
        setAttachmentName(data.greetingMediaAttachment);
        setAutoToken(data.token);
        data.promptId
          ? setSelectedPrompt(data.promptId)
          : setSelectedPrompt(null);
        const whatsQueueIds = data.queues?.map((queue) => queue.id);
        setSelectedQueueIds(whatsQueueIds);
        // Gallera Voz: lista de quem recebe ligações (CSV → array de ids)
        setVoiceRingUserIds(
          data.voiceRingUsers
            ? String(data.voiceRingUsers)
                .split(",")
                .map((s) => parseInt(s.trim(), 10))
                .filter((n) => Number.isFinite(n) && n > 0)
            : []
        );
        // Gallera Voz: token da conexão (vínculo com o painel .254)
        setVoiceToken(data.voiceToken || "");
        setIsOficial(channel === "whatsapp_oficial");
        setSchedules(data.schedules);
        if (!isNil(data?.importOldMessages)) {
          setEnableImportMessage(true);
          setImportOldMessages(data?.importOldMessages);
          setImportRecentMessages(data?.importRecentMessages);
          setClosedTicketsPostImported(data?.closedTicketsPostImported);
          setImportOldMessagesGroups(data?.importOldMessagesGroups);
        }
        // Disparar Integração ao Encerrar Ticket: restaurar valores salvos para persistir no formulário
        setTriggerIntegrationOnClose(
          data.triggerIntegrationOnClose !== undefined
            ? data.triggerIntegrationOnClose
            : true
        );
        setTriggerIntegrationOnCloseMode(
          data.triggerIntegrationOnCloseMode || "ask"
        );
        setIntegrationTypeId(
          data.integrationTypeId != null ? data.integrationTypeId : null
        );
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
    
    // Para WebChat novo, definir tab inicial como "widget" e carregar código
    if (channel === "webchat" && !whatsAppId && open) {
      setTab("widget");
      // Conexão WebChat nova já nasce ligada — o admin a criou para usar.
      setWhatsApp((prev) => ({ ...prev, webchatEnabled: true }));
    }
  }, [whatsAppId, channel, open]);

  useEffect(() => {
    if (!open || attachment) return;
    if (!attachmentName) {
      setAttachmentPreviewUrl((prev) => {
        revokeObjectUrlIfBlob(prev);
        return "";
      });
      return;
    }
    const url = getGreetingMediaPublicUrl(attachmentName, user?.companyId);
    setAttachmentPreviewUrl((prev) => {
      revokeObjectUrlIfBlob(prev);
      return url;
    });
  }, [open, attachment, attachmentName, user?.companyId]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queueIntegration");

        setIntegrations(data.queueIntegrations);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleChangeQueue = (e) => {
    const newSelected = e || [];
    const max =
      chatBotType === "button" ? 3 : chatBotType === "list" ? 10 : Infinity;

    if (newSelected.length > max) {
      if (chatBotType === "button") {
        toast.error("Tipo Botões permite no máximo 3 filas.");
      } else if (chatBotType === "list") {
        toast.error("Tipo Lista permite no máximo 10 filas.");
      }
      return;
    }

    setSelectedQueueIds(newSelected);
    setSelectedPrompt(null);
  };

  const handleChangePrompt = (e) => {
    setSelectedPrompt(e.target.value);
    setSelectedQueueIds([]);
  };

  const handleChange = (e) => {
    setTriggerIntegrationOnClose(e.target.value);
  };

  const handleChangeTriggerIntegrationOnCloseMode = (e) => {
    setTriggerIntegrationOnCloseMode(e.target.value);
  };

  const handleIntegrationTypeChange = (e) => {
    setIntegrationType(e.target.value);
    setIntegrationTypeId(e.target.value);
  };

  const handleExecutePinAction = async () => {
    if (!whatsAppId) return;
    try {
      await api.post(`/whatsapp/${whatsAppId}/pin-action`);
      toast.success("Configuração executada com sucesso!");
    } catch (err) {
      toastError(err);
    }
  };

  const [webchatCode, setWebchatCode] = useState('');
  const [webchatPwaUrl, setWebchatPwaUrl] = useState('');
  // 16/09/2026: o backend passou a dizer o que falta para o Gallera Chat funcionar nesta empresa
  const [webchatDiag, setWebchatDiag] = useState(null);
  const webchatCodeGeneratedRef = useRef(false);
  const [webchatAllowedDomains, setWebchatAllowedDomains] = useState([]);
  const [webchatDomainInput, setWebchatDomainInput] = useState("");
  const [savingWebchatDomains, setSavingWebchatDomains] = useState(false);

  const generateWebChatCode = useCallback(async () => {
    // Se já foi gerado, não gerar novamente
    if (webchatCodeGeneratedRef.current) {
      return;
    }
    
    webchatCodeGeneratedRef.current = true;
    
    const backendBaseRaw = getBackendUrl() || window.location.origin;
    // Evita casos onde o env vem com "/api" no final (e o embed acabaria virando ".../api/public")
    const backendBaseNoApi = String(backendBaseRaw).replace(/\/api\/?$/, '');
    const apiBase = backendBaseNoApi.replace(/\/$/, '') + '/api';
    
    // Buscar UUID do webchat
    let uuid = '';
    try {
      const { data } = await api.get("/webchat/uuid");
      if (data && data.diagnostico) setWebchatDiag(data.diagnostico);
      uuid = data.uuid;
      setWebchatAllowedDomains(
        Array.isArray(data.allowedDomains) ? data.allowedDomains : []
      );
      // Gallera Chat PWA: o backend devolve a base pronta (pwaUrl);
      // o helper é só plano B para servidor antigo.
      setWebchatPwaUrl(data.pwaUrl || getWebChatPwaBaseUrl());
    } catch (err) {
      console.error("Erro ao obter UUID do webchat:", err);
      toast.error("Erro ao gerar código do webchat. Tente novamente.");
      webchatCodeGeneratedRef.current = false;
      return;
    }
    
    const code = `<script>
  window.WEBCHAT_CONFIG = {
    apiBase: '${apiBase}',
    uuid: '${uuid}'
  };
</script>
<script src="${backendBaseNoApi}/public/webchat-widget.js"></script>`;
    
    setWebchatCode(code);
  }, []);

  const handleCopyWebChatCode = () => {
    if (!webchatCode) {
      toast.error("Aguarde o código ser gerado...");
      return;
    }
    
    navigator.clipboard.writeText(webchatCode).then(() => {
      setCopied(true);
      toast.success("Código copiado para a área de transferência!");
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      toastError(err);
    });
  };

  const handleCopyWebchatPwaUrl = () => {
    if (!webchatPwaUrl) {
      toast.error("Aguarde o link ser gerado...");
      return;
    }

    navigator.clipboard
      .writeText(webchatPwaUrl)
      .then(() => {
        toast.success("Link do aplicativo copiado!");
      })
      .catch((err) => {
        toastError(err);
      });
  };

  const handleAddWebchatDomain = () => {
    const t = String(webchatDomainInput || "").trim().toLowerCase();
    if (!t) {
      toast.error("Indique um domínio ou URL do site onde o widget vai ficar.");
      return;
    }
    let host = t;
    try {
      if (t.includes("://")) {
        host = new URL(t).hostname;
      } else {
        host = t.split("/")[0].split(":")[0];
      }
    } catch {
      toast.error("URL inválida.");
      return;
    }
    if (!host || !/^[a-z0-9.-]+$/.test(host)) {
      toast.error("Domínio inválido.");
      return;
    }
    if (webchatAllowedDomains.includes(host)) {
      toast.info("Este domínio já está na lista.");
      return;
    }
    if (webchatAllowedDomains.length >= 30) {
      toast.error("Máximo de 30 domínios.");
      return;
    }
    setWebchatAllowedDomains((prev) => [...prev, host]);
    setWebchatDomainInput("");
  };

  const handleRemoveWebchatDomain = (host) => {
    setWebchatAllowedDomains((prev) => prev.filter((d) => d !== host));
  };

  const handleSaveWebchatDomains = async () => {
    setSavingWebchatDomains(true);
    try {
      const { data } = await api.put("/webchat/allowed-domains", {
        domains: webchatAllowedDomains,
      });
      const saved = Array.isArray(data.allowedDomains) ? data.allowedDomains : [];
      setWebchatAllowedDomains(saved);
      if (saved.length === 0) {
        toast.success("Lista vazia: qualquer site pode usar o widget.");
      } else {
        toast.success("Domínios guardados. Só estes sites poderão usar o WebChat.");
      }
    } catch (err) {
      toastError(err);
    } finally {
      setSavingWebchatDomains(false);
    }
  };

  const handleSaveWhatsApp = async (values) => {
    if (!whatsAppId) setAutoToken(generateRandomCode(30));

    if (NPSEnabled) {
      if (isNil(values.ratingMessage)) {
        toastError(i18n.t("whatsappModal.errorRatingMessage"));
        return;
      }

      if (
        values.expiresTicketNPS === "0" &&
        values.expiresTicketNPS === "" &&
        values.expiresTicketNPS === 0
      ) {
        toastError(i18n.t("whatsappModal.errorExpiresNPS"));
        return;
      }
    }

    /* 22/09/2026 — vazio no banco chega como null, não "": era tratado como "tempo informado sem fila"
       e NENHUMA edição salvava (ex.: a conexão WebChat, que nasce sem esse campo — a chave "Chat ligado"
       não gravava). Vazio, null ou indefinido = 0 (sem redirecionamento), como sempre foi a intenção. */
    if (values.timeSendQueue === "" || values.timeSendQueue === null || values.timeSendQueue === undefined) {
      values.timeSendQueue = "0";
    }

    if (
      (values.sendIdQueue === 0 ||
        values.sendIdQueue === "" ||
        isNil(values.sendIdQueue)) &&
      values.timeSendQueue !== 0 &&
      values.timeSendQueue !== "0"
    ) {
      toastError(i18n.t("whatsappModal.errorSendQueue"));
      return;
    }

    const expiresTicketMinutes = Number(values.expiresTicket || 0);
    if (
      !Number.isNaN(expiresTicketMinutes) &&
      expiresTicketMinutes > 0 &&
      expiresTicketMinutes < MIN_EXPIRES_TICKET_MINUTES
    ) {
      toast.error(`Tempo minimo para encerramento: ${MIN_EXPIRES_TICKET_MINUTES} minutos.`);
      return;
    }

    const inactiveWarningMinutes = Number(values.timeInactiveMessage || 0);
    if (
      !Number.isNaN(inactiveWarningMinutes) &&
      inactiveWarningMinutes > 0 &&
      inactiveWarningMinutes < MIN_INACTIVE_WARNING_MINUTES
    ) {
      toast.error(`Tempo minimo para aviso de inatividade: ${MIN_INACTIVE_WARNING_MINUTES} minutos.`);
      return;
    }

    const finalChannel = channel;

    const whatsappData = {
      ...values,
      flowIdWelcome: flowIdWelcome ? flowIdWelcome : null,
      flowIdInactiveTime: flowIdInactiveTime ? flowIdInactiveTime : null,
      flowIdNotPhrase: flowIdNotPhrase ? flowIdNotPhrase : null,
      timeAwaitActiveFlowId: timeAwaitActiveFlowId
        ? timeAwaitActiveFlowId
        : null,
      queueIds: selectedQueueIds,
      // Gallera Voz: quem recebe as ligações desta conexão (CSV; null = todos)
      voiceRingUsers: voiceRingUserIds.length ? voiceRingUserIds.join(",") : null,
      // Gallera Voz: token da conexão (vínculo com o painel .254); vazio = sem voz
      voiceToken: voiceToken && voiceToken.trim() ? voiceToken.trim() : null,
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: importOldMessagesGroups
        ? importOldMessagesGroups
        : null,
      closedTicketsPostImported: closedTicketsPostImported
        ? closedTicketsPostImported
        : null,
      token: autoToken ? autoToken : null,
      schedules,
      promptId: selectedPrompt ? selectedPrompt : null,
      channel: finalChannel,
      triggerIntegrationOnClose: triggerIntegrationOnClose,
      triggerIntegrationOnCloseMode: triggerIntegrationOnClose
        ? triggerIntegrationOnCloseMode
        : "ask",
      integrationTypeId: triggerIntegrationOnClose ? integrationTypeId : null,
      color: values.color ? values.color : getRandomHexColor(),
      wavoip: values.wavoip ? values.wavoip : null,
    };
    delete whatsappData["queues"];
    delete whatsappData["session"];
    delete whatsappData["whatsappProvider"];

    try {
      if (whatsAppId) {
        if (
          whatsAppId &&
          enableImportMessage &&
          whatsApp?.status === "CONNECTED"
        ) {
          try {
            setWhatsApp({ ...whatsApp, status: "qrcode" });
            await api.delete(`/whatsappsession/${whatsApp.id}`);
          } catch (err) {
            toastError(err);
          }
        }

        await api.put(`/whatsapp/${whatsAppId}`, whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${whatsAppId}/media-upload`, formData);
        }
        if (!attachmentName && whatsApp.greetingMediaAttachment !== null) {
          await api.delete(`/whatsapp/${whatsAppId}/media-upload`);
        }
      } else {
        const { data } = await api.post("/whatsapp", whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${data.id}/media-upload`, formData);
        }
      }
      toast.success(i18n.t("whatsappModal.success"));

      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  function generateRandomCode(length) {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyvz0123456789";
    let code = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  const handleRefreshToken = () => {
    setAutoToken(generateRandomCode(30));
  };

  const handleChangeFlowIdNotPhrase = (e) => {
    console.log(e.target.value);
    setFlowIdNotPhrase(e.target.value);
  };

  const handleChangeFlowIdWelcome = (e) => {
    setFlowIdWelcome(e.target.value);
  };

  const handleChangeFlowIdInactiveTime = (e) => {
    setFlowIdInactiveTime(e.target.value);
  };

  const handleChangeTimeAwaitActiveFlowId = (e) => {
    setTimeAwaitActiveFlowId(e.target.value);
  };

  const handleCopyToken = () => {
    navigator.clipboard.writeText(autoToken); // Copia o token para a área de transferência
    setCopied(true); // Define o estado de cópia como verdadeiro
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Clique em salvar para registar as alterações");
    setSchedules(values);
  };

  const handleClose = () => {
    setAttachmentPreviewUrl((prev) => {
      revokeObjectUrlIfBlob(prev);
      return "";
    });
    onClose();
    setWhatsApp(initialState);
    setEnableImportMessage(false);
    // inputFileRef.current.value = null
    setAttachment(null);
    setAttachmentName("");
    setCopied(false);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    // Gerar código do webchat quando a aba "widget" for selecionada
    if (newValue === "widget" && channel === "webchat" && !webchatCodeGeneratedRef.current) {
      generateWebChatCode();
    }
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    if (!file) return;
    setAttachment(file);
    setAttachmentName(file.name);
    setAttachmentPreviewUrl((prev) => {
      revokeObjectUrlIfBlob(prev);
      return URL.createObjectURL(file);
    });
    inputFileRef.current.value = null;
  };

  const handleDeleFile = () => {
    setAttachmentPreviewUrl((prev) => {
      revokeObjectUrlIfBlob(prev);
      return "";
    });
    setAttachment(null);
    setAttachmentName("");
  };

  // Quando abrir modal para WebChat, mudar para aba widget e gerar código
  useEffect(() => {
    if (open && channel === "webchat") {
      setTab("widget");
      // Gerar código do webchat apenas uma vez quando abrir
      if (!webchatCodeGeneratedRef.current) {
        generateWebChatCode();
      }
    } else if (!open) {
      // Resetar quando fechar o modal
      setWebchatCode('');
      webchatCodeGeneratedRef.current = false;
      setWebchatAllowedDomains([]);
      setWebchatDomainInput("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, channel]);

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {((channel && ["wuzapi", "whatsmeow"].includes(channel.toLowerCase())) ||
              (whatsApp?.channel && ["wuzapi", "whatsmeow"].includes(whatsApp.channel.toLowerCase()))) && (
              <img
                src={whatsmeowIcon}
                alt="Whatsapp01"
                style={{ width: 24, height: 24, objectFit: "contain" }}
              />
            )}
            {(channel === "waha" || whatsApp?.channel === "waha") && (
              <img
                src={wahaIcon}
                alt="Whatsapp02"
                style={{ width: 24, height: 24, objectFit: "contain" }}
              />
            )}
            {(channel === "evolution" || whatsApp?.channel === "evolution") && (
              <img
                src={evolutionIcon}
                alt="Whatsapp03"
                style={{ width: 24, height: 24, objectFit: "contain" }}
              />
            )}
            <span>
              {whatsAppId
                ? i18n.t("whatsappModal.title.edit")
                : channel === "webchat" 
                  ? "Nova Conexão WebChat"
                  : channel === "wuzapi"
                  ? "Nova Conexão gallera.net"
                  : channel === "waha"
                  ? "Nova Conexão Whatsapp02"
                  : channel === "evolution"
                  ? "Nova Conexão Whatsapp03"
                  : i18n.t("whatsappModal.title.add")}
            </span>
          </div>
        </DialogTitle>
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveWhatsApp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting, setFieldValue }) => (
            <Form>
              <Paper className={classes.mainPaper} elevation={1}>
                <Tabs
                  value={tab}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="on"
                  variant="scrollable"
                  onChange={handleTabChange}
                  className={classes.tab}
                >
                  <Tab
                    label={i18n.t("whatsappModal.tabs.general")}
                    value={"general"}
                  />
                  <Tab
                    label={i18n.t("whatsappModal.tabs.integrations")}
                    value={"integrations"}
                  />
                  <Tab
                    label={i18n.t("whatsappModal.tabs.messages")}
                    value={"messages"}
                  />
                  <Tab label="Chatbot" value={"chatbot"} />
                  <Tab
                    label={i18n.t("whatsappModal.tabs.assessments")}
                    value={"nps"}
                  />
                  {user.showFlow === "enabled" && (
                    <Tab label="Fluxo Padrão" value={"flowbuilder"} />
                  )}
                  {schedulesEnabled && (
                    <Tab
                      label={i18n.t("whatsappModal.tabs.schedules")}
                      value={"schedules"}
                    />
                  )}
                  {channel === "webchat" && (
                    <Tab label="Código do Widget" value={"widget"} />
                  )}
                </Tabs>
              </Paper>
              <Paper className={classes.paper} elevation={0}>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"general"}
                >
                  <DialogContent dividers>
                    {(attachmentName || attachment) && (
                      <GreetingMediaAttachmentPreview
                        previewUrl={attachmentPreviewUrl}
                        fileName={attachmentName}
                        file={attachment}
                        onDelete={handleDeleFile}
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column-reverse",
                      }}
                    >
                      <input
                        type="file"
                        accept="video/*,image/*"
                        ref={inputFileRef}
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => inputFileRef.current.click()}
                      >
                        {i18n.t("userModal.buttons.addImage")}
                      </Button>
                    </div>
                    {/* GALLERA CHAT: liga/desliga desta conexão */}
                    <WebchatConnectionSwitch
                      channel={channel}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                    {/* NOME E COR */}
                    <div className={classes.multFieldLine}>
                      <Grid spacing={2} container alignItems="center">
                        <Grid xs={12} md={4} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.name")}
                            autoFocus
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          />
                        </Grid>
                        <Grid xs={6} md={3} item>
                          <Field
                            as={TextField}
                            label={i18n.t("connections.table.color")}
                            name="color"
                            id="color"
                            onFocus={() => {
                              setColorPickerModalOpen(false);
                            }}
                            error={touched.color && Boolean(errors.color)}
                            helperText={touched.color && errors.color}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div
                                    style={{ backgroundColor: values.color }}
                                    className={classes.colorAdorment}
                                  ></div>
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <IconButton
                                  size="small"
                                  color="default"
                                  onClick={() => setColorPickerModalOpen(true)}
                                >
                                  <Colorize />
                                </IconButton>
                              ),
                            }}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          />
                          <ColorPicker
                            open={colorPickerModalOpen}
                            handleClose={() => setColorPickerModalOpen(false)}
                            onChange={(color) => {
                              values.color = color;
                              setWhatsApp(() => {
                                return { ...values, color };
                              });
                            }}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    {/* TOGGLES */}
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 4, marginTop: 8, marginBottom: 8 }}>
                      <FormControlLabel
                        control={
                          <Field
                            as={Switch}
                            color="primary"
                            name="isDefault"
                            checked={values.isDefault}
                          />
                        }
                        label={i18n.t("whatsappModal.form.default")}
                      />
                      {useWhatsappOfficial &&
                        channel === "whatsapp_oficial" && (
                          <FormControlLabel
                            style={{ color: "gray" }}
                            label={i18n.t("whatsappModal.form.isOficial")}
                            labelPlacement="end"
                            control={
                              <Switch
                                size="medium"
                                checked={isOficial}
                                onChange={handleEnableIsOficial}
                                name="isOficial"
                                color="primary"
                              />
                            }
                          />
                        )}
                      <FormControlLabel
                        control={
                          <Field
                            as={Switch}
                            color="primary"
                            name="allowGroup"
                            checked={values.allowGroup}
                          />
                        }
                        label={i18n.t("whatsappModal.form.group")}
                      />
                      <Tooltip
                        title={i18n.t("whatsappModal.form.inboundOnlyHelper")}
                        placement="top"
                        arrow
                      >
                        <FormControlLabel
                          control={
                            <Field
                              as={Switch}
                              color="primary"
                              name="inboundOnly"
                              checked={!!values.inboundOnly}
                            />
                          }
                          label={i18n.t("whatsappModal.form.inboundOnly")}
                        />
                      </Tooltip>
                      <FormControlLabel
                        control={
                          <Field
                            as={Switch}
                            color="primary"
                            name="groupAsTicket"
                            checked={values.groupAsTicket === "enabled"}
                            onChange={(e) => {
                              setFieldValue("groupAsTicket", e.target.checked ? "enabled" : "disabled");
                            }}
                          />
                        }
                        label={i18n.t("whatsappModal.form.groupAsTicket")}
                      />
                      <Tooltip
                        title="Rejeita chamadas de voz/vídeo e envia uma mensagem automática"
                        placement="top"
                        arrow
                      >
                        <FormControlLabel
                          control={
                            <Field
                              as={Switch}
                              color="primary"
                              name="rejectCalls"
                              checked={values.rejectCalls === "enabled"}
                              onChange={(e) => {
                                setFieldValue("rejectCalls", e.target.checked ? "enabled" : "disabled");
                              }}
                            />
                          }
                          label="Rejeitar chamadas"
                        />
                      </Tooltip>
                    </div>

                    {values.rejectCalls === "enabled" && (
                      <div style={{ marginBottom: 8 }}>
                        <Field
                          as={TextField}
                          label="Mensagem ao rejeitar chamada"
                          multiline
                          rows={2}
                          fullWidth
                          name="rejectCallMessage"
                          placeholder="As chamadas de voz e vídeo estão desabilitadas para esse WhatsApp, favor enviar uma mensagem de texto."
                          variant="outlined"
                          margin="dense"
                        />
                      </div>
                    )}

                    {isOficial && (
                      <div className={classes.importMessage}>
                        <Grid style={{ marginTop: 18 }} container spacing={1}>
                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t(
                                "whatsappModal.form.phone_number_id"
                              )}
                              name="phone_number_id"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.phone_number_id &&
                                Boolean(errors.phone_number_id)
                              }
                              helperText={
                                touched.phone_number_id &&
                                errors.phone_number_id
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>
                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.waba_id")}
                              name="waba_id"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={touched.waba_id && Boolean(errors.waba_id)}
                              helperText={touched.waba_id && errors.waba_id}
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>

                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.business_id")}
                              name="business_id"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.business_id &&
                                Boolean(errors.business_id)
                              }
                              helperText={
                                touched.business_id && errors.business_id
                              }
                              variant="outlined"
                            />
                          </Grid>
                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.phone_number")}
                              name="phone_number"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.phone_number &&
                                Boolean(errors.phone_number)
                              }
                              helperText={
                                touched.phone_number && errors.phone_number
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>
                          <Grid xs={12} md={12} xl={12} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.send_token")}
                              name="send_token"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.send_token && Boolean(errors.send_token)
                              }
                              helperText={
                                touched.send_token && errors.send_token
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>

                          <Grid xs={12} md={12} xl={12} item>
                            <FormControlLabel
                              control={
                                <Field
                                  as={Switch}
                                  color="primary"
                                  name="enableWhatsappPin"
                                  checked={values.enableWhatsappPin}
                                />
                              }
                              label="Habilitar PIN"
                            />
                          </Grid>

                          {values.enableWhatsappPin && (
                            <Grid xs={12} md={12} xl={12} item>
                              <Field
                                fullWidth
                                as={TextField}
                                label="PIN do WhatsApp"
                                name="whatsappPin"
                                variant="outlined"
                                margin="dense"
                              />
                            </Grid>
                          )}

                          <Grid xs={12} md={12} xl={12} item>
                            <FormControlLabel
                              control={
                                <Field
                                  as={Switch}
                                  color="primary"
                                  name="secondaryConnection"
                                  checked={values.secondaryConnection}
                                />
                              }
                              label="Conexão Secundária (Override Webhook)"
                            />
                          </Grid>

                          <Grid xs={12} md={12} xl={12} item>
                            <Box display="flex" alignItems="center" style={{ marginTop: 10, gap: 12 }}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleExecutePinAction}
                                disabled={!whatsAppId}
                              >
                                Configurar API Oficial
                              </Button>
                              
                              <Box 
                                display="flex" 
                                alignItems="center" 
                                style={{ cursor: "pointer", color: "#f50057" }}
                                onClick={handleHelpClick}
                              >
                                <HelpOutlineIcon style={{ marginRight: 4 }} />
                                <Typography variant="body2" style={{ fontWeight: 500 }}>
                                  Ajuda
                                </Typography>
                              </Box>
                              
                              <Popover
                                open={helpOpen}
                                anchorEl={helpAnchorEl}
                                onClose={handleHelpClose}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                                PaperProps={{
                                  style: {
                                    maxWidth: 450,
                                    padding: 20,
                                    borderRadius: 8,
                                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
                                  }
                                }}
                              >
                                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12, color: "#1976d2" }}>
                                  📱 Como Ativar mais de 1 Conexão Oficial na mesma Empresa
                                </Typography>
                                
                                <Box style={{ 
                                  backgroundColor: "#f5f5f5", 
                                  borderRadius: 8, 
                                  padding: 12,
                                  marginBottom: 8
                                }}>
                                  <Typography variant="body2" component="div" style={{ lineHeight: 2 }}>
                                    <strong style={{ color: "#1976d2" }}>1.</strong> Preencha normalmente os dados da sua segunda conexão com a API Oficial.<br/>
                                    <strong style={{ color: "#1976d2" }}>2.</strong> Habilite e Preencha o <strong>PIN</strong> (Confirmação de duas etapas - necessário ativar na Meta).<br/>
                                    <strong style={{ color: "#1976d2" }}>3.</strong> Marque a opção <strong>"Conexão Secundária"</strong>.<br/>
                                    <strong style={{ color: "#1976d2" }}>4.</strong> Clique em <strong>Salvar</strong>.<br/>
                                    <strong style={{ color: "#1976d2" }}>5.</strong> Edite a conexão Oficial que você acabou de criar.<br/>
                                    <strong style={{ color: "#1976d2" }}>6.</strong> Clique no botão <strong>"CONFIGURAR API OFICIAL"</strong>.<br/>
                                    <strong style={{ color: "#1976d2" }}>7.</strong> Salve e está pronto! ✅
                                  </Typography>
                                </Box>
                                
                                <Typography variant="caption" style={{ color: "#666", fontStyle: "italic" }}>
                                  💡 Dica: O PIN é obrigatório para conexões secundárias na mesma empresa.
                                </Typography>
                              </Popover>
                            </Box>
                          </Grid>
                        </Grid>
                      </div>
                    )}
                    {!isOficial &&
                      channel !== "wuzapi" &&
                      channel !== "whatsmeow" &&
                      channel !== "waha" &&
                      channel !== "evolution" && (
                      <div className={classes.importMessage}>
                        <div className={classes.multFieldLine}>
                          <FormControlLabel
                            style={{ marginRight: 7, color: "gray" }}
                            label={i18n.t(
                              "whatsappModal.form.importOldMessagesEnable"
                            )}
                            labelPlacement="end"
                            control={
                              <Switch
                                size="medium"
                                checked={enableImportMessage}
                                onChange={handleEnableImportMessage}
                                name="importOldMessagesEnable"
                                color="primary"
                              />
                            }
                          />

                          {enableImportMessage ? (
                            <>
                              <FormControlLabel
                                style={{ marginRight: 7, color: "gray" }}
                                label={i18n.t(
                                  "whatsappModal.form.importOldMessagesGroups"
                                )}
                                labelPlacement="end"
                                control={
                                  <Switch
                                    size="medium"
                                    checked={importOldMessagesGroups}
                                    onChange={(e) =>
                                      setImportOldMessagesGroups(
                                        e.target.checked
                                      )
                                    }
                                    name="importOldMessagesGroups"
                                    color="primary"
                                  />
                                }
                              />

                              <FormControlLabel
                                style={{ marginRight: 7, color: "gray" }}
                                label={i18n.t(
                                  "whatsappModal.form.closedTicketsPostImported"
                                )}
                                labelPlacement="end"
                                control={
                                  <Switch
                                    size="medium"
                                    checked={closedTicketsPostImported}
                                    onChange={(e) =>
                                      setClosedTicketsPostImported(
                                        e.target.checked
                                      )
                                    }
                                    name="closedTicketsPostImported"
                                    color="primary"
                                  />
                                }
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </div>

                        {enableImportMessage ? (
                          <Grid style={{ marginTop: 18 }} container spacing={1}>
                            <Grid item xs={6}>
                              <Field
                                fullWidth
                                as={TextField}
                                label={i18n.t(
                                  "whatsappModal.form.importOldMessages"
                                )}
                                type="datetime-local"
                                name="importOldMessages"
                                inputProps={{
                                  max: moment()
                                    .add(0, "minutes")
                                    .format("YYYY-MM-DDTHH:mm"),
                                  min: moment()
                                    .add(-2, "years")
                                    .format("YYYY-MM-DDTHH:mm"),
                                }}
                                //min="2022-11-06T22:22:55"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                error={
                                  touched.importOldMessages &&
                                  Boolean(errors.importOldMessages)
                                }
                                helperText={
                                  touched.importOldMessages &&
                                  errors.importOldMessages
                                }
                                variant="outlined"
                                value={moment(importOldMessages).format(
                                  "YYYY-MM-DDTHH:mm"
                                )}
                                onChange={(e) => {
                                  setImportOldMessages(e.target.value);
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Field
                                fullWidth
                                as={TextField}
                                label={i18n.t(
                                  "whatsappModal.form.importRecentMessages"
                                )}
                                type="datetime-local"
                                name="importRecentMessages"
                                inputProps={{
                                  max: moment()
                                    .add(0, "minutes")
                                    .format("YYYY-MM-DDTHH:mm"),
                                  min: moment(importOldMessages).format(
                                    "YYYY-MM-DDTHH:mm"
                                  ),
                                }}
                                //min="2022-11-06T22:22:55"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                error={
                                  touched.importRecentMessages &&
                                  Boolean(errors.importRecentMessages)
                                }
                                helperText={
                                  touched.importRecentMessages &&
                                  errors.importRecentMessages
                                }
                                variant="outlined"
                                value={moment(importRecentMessages).format(
                                  "YYYY-MM-DDTHH:mm"
                                )}
                                onChange={(e) => {
                                  setImportRecentMessages(e.target.value);
                                }}
                              />
                            </Grid>
                            <Grid xs={12} md={12} xl={12} item>
                              <FormControl
                                variant="outlined"
                                margin="dense"
                                className={classes.FormControl}
                                fullWidth
                              >
                                <InputLabel id="queueIdImportMessages-selection-label">
                                  {i18n.t(
                                    "whatsappModal.form.queueIdImportMessages"
                                  )}
                                </InputLabel>
                                <Field
                                  as={Select}
                                  name="queueIdImportMessages"
                                  id="queueIdImportMessages"
                                  value={values.queueIdImportMessages || "0"}
                                  required={enableImportMessage}
                                  label={i18n.t(
                                    "whatsappModal.form.queueIdImportMessages"
                                  )}
                                  placeholder={i18n.t(
                                    "whatsappModal.form.queueIdImportMessages"
                                  )}
                                  labelId="queueIdImportMessages-selection-label"
                                >
                                  <MenuItem value={0}>&nbsp;</MenuItem>
                                  {queues.map((queue) => (
                                    <MenuItem key={queue.id} value={queue.id}>
                                      {queue.name}
                                    </MenuItem>
                                  ))}
                                </Field>
                              </FormControl>
                            </Grid>
                          </Grid>
                        ) : null}
                      </div>
                    )}
                    {enableImportMessage && (
                      <span style={{ color: "red" }}>
                        {i18n.t("whatsappModal.form.importAlert")}
                      </span>
                    )}

                    {/* TOKEN */}
                    <Box display="flex" alignItems="center">
                      <Grid xs={6} md={12} item>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.token")}
                          type="token"
                          fullWidth
                          // name="token"
                          value={autoToken}
                          variant="outlined"
                          margin="dense"
                          disabled
                        />
                      </Grid>
                      <Button
                        onClick={handleRefreshToken}
                        disabled={isSubmitting}
                        className={classes.tokenRefresh}
                        variant="text"
                        startIcon={
                          <Autorenew
                            style={{ marginLeft: 5, color: "green" }}
                          />
                        }
                      />
                      <Button
                        onClick={handleCopyToken}
                        className={classes.tokenRefresh}
                        variant="text"
                        startIcon={
                          <FileCopy
                            style={{ color: copied ? "blue" : "inherit" }}
                          />
                        }
                      />
                    </Box>

                    <div>
                      <h3>{i18n.t("whatsappModal.form.queueRedirection")}</h3>
                      <p>{i18n.t("whatsappModal.form.queueRedirectionDesc")}</p>
                      <Grid spacing={2} container>
                        <Grid xs={6} md={6} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            className={classes.FormControl}
                            fullWidth
                          >
                            <InputLabel id="sendIdQueue-selection-label">
                              {i18n.t("whatsappModal.form.sendIdQueue")}
                            </InputLabel>
                            <Field
                              as={Select}
                              name="sendIdQueue"
                              id="sendIdQueue"
                              value={values.sendIdQueue || "0"}
                              required={values.timeSendQueue > 0}
                              label={i18n.t("whatsappModal.form.sendIdQueue")}
                              placeholder={i18n.t(
                                "whatsappModal.form.sendIdQueue"
                              )}
                              labelId="sendIdQueue-selection-label"
                            >
                              <MenuItem value={0}>&nbsp;</MenuItem>
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </Grid>

                        <Grid xs={6} md={6} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.timeSendQueue")}
                            fullWidth
                            name="timeSendQueue"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.timeSendQueue &&
                              Boolean(errors.timeSendQueue)
                            }
                            helperText={
                              touched.timeSendQueue && errors.timeSendQueue
                            }
                          />
                        </Grid>
                      </Grid>
                    </div>

                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"integrations"}
                >
                  <DialogContent dividers>
                    <QueueSelect
                      selectedQueueIds={selectedQueueIds}
                      onChange={(selectedIds) => handleChangeQueue(selectedIds)}
                    />
                    {/* Gallera Voz: roteamento por conexão — quem recebe as ligações */}
                    <FormControl variant="outlined" margin="dense" fullWidth>
                      <InputLabel id="voice-ring-users-label">
                        Gallera Voz — quem recebe ligações (vazio = todos)
                      </InputLabel>
                      <Select
                        labelId="voice-ring-users-label"
                        label="Gallera Voz — quem recebe ligações (vazio = todos)"
                        multiple
                        value={voiceRingUserIds}
                        onChange={(e) => setVoiceRingUserIds(e.target.value)}
                        renderValue={(selected) => (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                            {selected.map((id) => {
                              const u = companyUsers.find(
                                (x) => Number(x.id) === Number(id)
                              );
                              return (
                                <Chip key={id} size="small" label={u?.name || id} />
                              );
                            })}
                          </div>
                        )}
                      >
                        {companyUsers.map((u) => (
                          <MenuItem key={u.id} value={u.id}>
                            {u.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/* Gallera Voz: TOKEN da conexão (vínculo com o painel de voz .254) */}
                    <TextField
                      label="Token de voz (Gallera Voz)"
                      placeholder="gvz_... (cole o token gerado no painel de voz)"
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={voiceToken}
                      onChange={(e) => setVoiceToken(e.target.value)}
                      helperText="Cole aqui o token gerado no painel de voz para vincular a voz a esta conexão. Vazio = sem voz."
                    />
                    {showWavoipCall && (
                      <div>
                        <Field
                          as={TextField}
                          label="Voz Externa"
                          fullWidth
                          name="wavoip"
                          variant="outlined"
                          margin="dense"
                        />
                      </div>
                    )}
                    {showIntegrations && (
                      <FormControl
                        variant="outlined"
                        margin="dense"
                        className={classes.FormControl}
                        fullWidth
                      >
                        <InputLabel id="integrationId-selection-label">
                          {i18n.t("queueModal.form.integrationId")}
                        </InputLabel>
                        <Field
                          as={Select}
                          label={i18n.t("queueModal.form.integrationId")}
                          name="integrationId"
                          id="integrationId"
                          variant="outlined"
                          margin="dense"
                          placeholder={i18n.t("queueModal.form.integrationId")}
                          labelId="integrationId-selection-label"
                        >
                          <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                          {integrations.map((integration) => (
                            <MenuItem
                              key={integration.id}
                              value={integration.id}
                            >
                              {integration.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    )}
                    {showOpenAi && (
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel>
                          {i18n.t("whatsappModal.form.prompt")}
                        </InputLabel>
                        <Select
                          labelId="dialog-select-prompt-label"
                          id="dialog-select-prompt"
                          name="promptId"
                          value={selectedPrompt || ""}
                          onChange={handleChangePrompt}
                          label={i18n.t("whatsappModal.form.prompt")}
                          fullWidth
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                        >
                          {prompts.map((prompt) => (
                            <MenuItem key={prompt.id} value={prompt.id}>
                              {prompt.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    <Grid spacing={3} container>
                      <Grid xs={12} item>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          className={classes.FormControl}
                          fullWidth
                        >
                          <InputLabel id="triggerIntegrationOnClose-selection-label">
                            {i18n.t(
                              "whatsappModal.form.triggerIntegrationOnClose"
                            )}
                          </InputLabel>

                          <Field
                            onChange={handleChange}
                            value={triggerIntegrationOnClose}
                            as={Select}
                            label={i18n.t(
                              "whatsappModal.form.triggerIntegrationOnClose"
                            )}
                            name="triggerIntegrationOnClose"
                            id="triggerIntegrationOnClose"
                            variant="outlined"
                            margin="dense"
                            placeholder={i18n.t(
                              "whatsappModal.form.triggerIntegrationOnClose"
                            )}
                            labelId="triggerIntegrationOnClose-selection-label"
                          >
                            <MenuItem value={false}>
                              {i18n.t("whatsappModal.menuItem.disabled")}
                            </MenuItem>
                            <MenuItem value={true}>
                              {i18n.t("whatsappModal.menuItem.enabled")}
                            </MenuItem>
                          </Field>
                        </FormControl>
                      </Grid>

                      {triggerIntegrationOnClose && (
                        <Grid xs={12} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            className={classes.FormControl}
                            fullWidth
                          >
                            <InputLabel id="triggerIntegrationOnCloseMode-selection-label">
                              {i18n.t(
                                "whatsappModal.form.triggerIntegrationOnCloseMode"
                              )}
                            </InputLabel>
                            <Field
                              as={Select}
                              label={i18n.t(
                                "whatsappModal.form.triggerIntegrationOnCloseMode"
                              )}
                              name="triggerIntegrationOnCloseMode"
                              id="triggerIntegrationOnCloseMode"
                              variant="outlined"
                              margin="dense"
                              labelId="triggerIntegrationOnCloseMode-selection-label"
                              value={triggerIntegrationOnCloseMode}
                              onChange={handleChangeTriggerIntegrationOnCloseMode}
                            >
                              <MenuItem value="ask">
                                {i18n.t(
                                  "whatsappModal.menuItem.triggerIntegrationOnCloseModeAsk"
                                )}
                              </MenuItem>
                              <MenuItem value="trigger">
                                {i18n.t(
                                  "whatsappModal.menuItem.triggerIntegrationOnCloseModeTrigger"
                                )}
                              </MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                      )}

                      {triggerIntegrationOnClose && (
                        <Grid xs={12} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            className={classes.FormControl}
                            fullWidth
                          >
                            <InputLabel id="integrationType-selection-label">
                              {i18n.t("queueModal.form.integrationId")}
                            </InputLabel>
                            <Field
                              as={Select}
                              label={i18n.t("queueModal.form.integrationId")}
                              name="integrationType"
                              id="integrationType"
                              variant="outlined"
                              margin="dense"
                              placeholder={i18n.t(
                                "queueModal.form.integrationId"
                              )}
                              labelId="integrationType-selection-label"
                              value={integrationTypeId}
                              onChange={handleIntegrationTypeChange}
                            >
                              <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                              {integrations
                                .filter(
                                  (integration) =>
                                    integration.type === "n8n" ||
                                    integration.type === "typebot"
                                )
                                .map((integration) => (
                                  <MenuItem
                                    key={integration.id}
                                    value={integration.id}
                                  >
                                    {integration.name}
                                  </MenuItem>
                                ))}
                            </Field>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"messages"}
                >
                  <DialogContent dividers>
                    {/* MENSAGEM DE SAUDAÇÃO */}
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.greetingMessage")}
                          type="greetingMessage"
                          multiline
                          rows={4}
                          fullWidth
                          name="greetingMessage"
                          error={
                            touched.greetingMessage &&
                            Boolean(errors.greetingMessage)
                          }
                          helperText={
                            touched.greetingMessage && errors.greetingMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>

                      {/* MENSAGEM DE CONCLUSÃO */}
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.complationMessage")}
                          multiline
                          rows={4}
                          fullWidth
                          name="complationMessage"
                          error={
                            touched.complationMessage &&
                            Boolean(errors.complationMessage)
                          }
                          helperText={
                            touched.complationMessage &&
                            errors.complationMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>

                      {/* MENSAGEM DE FORA DE EXPEDIENTE */}
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.outOfHoursMessage")}
                          multiline
                          rows={4}
                          fullWidth
                          name="outOfHoursMessage"
                          error={
                            touched.outOfHoursMessage &&
                            Boolean(errors.outOfHoursMessage)
                          }
                          helperText={
                            touched.outOfHoursMessage &&
                            errors.outOfHoursMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      {/* MENSAGEM DE FÉRIAS COLETIVAS */}
                      <Grid item xs={12} md={12} xl={12}>
                        <Field
                          as={TextField}
                          label={i18n.t(
                            "whatsappModal.form.collectiveVacationMessage"
                          )}
                          multiline
                          rows={4}
                          fullWidth
                          name="collectiveVacationMessage"
                          error={
                            touched.collectiveVacationMessage &&
                            Boolean(errors.collectiveVacationMessage)
                          }
                          helperText={
                            touched.collectiveVacationMessage &&
                            errors.collectiveVacationMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          fullWidth
                          as={TextField}
                          label={i18n.t(
                            "whatsappModal.form.collectiveVacationStart"
                          )}
                          type="date"
                          name="collectiveVacationStart"
                          required={
                            values.collectiveVacationMessage?.length > 0
                          }
                          inputProps={{
                            min: moment().add(-10, "days").format("YYYY-MM-DD"),
                          }}
                          //min="2022-11-06T22:22:55"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={
                            touched.collectiveVacationStart &&
                            Boolean(errors.collectiveVacationStart)
                          }
                          helperText={
                            touched.collectiveVacationStart &&
                            errors.collectiveVacationStart
                          }
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          fullWidth
                          as={TextField}
                          label={i18n.t(
                            "whatsappModal.form.collectiveVacationEnd"
                          )}
                          type="date"
                          name="collectiveVacationEnd"
                          required={
                            values.collectiveVacationMessage?.length > 0
                          }
                          inputProps={{
                            min: moment().add(-10, "days").format("YYYY-MM-DD"),
                          }}
                          //min="2022-11-06T22:22:55"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={
                            touched.collectiveVacationEnd &&
                            Boolean(errors.collectiveVacationEnd)
                          }
                          helperText={
                            touched.collectiveVacationEnd &&
                            errors.collectiveVacationEnd
                          }
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                </TabPanel>

                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"chatbot"}
                >
                  <DialogContent dividers>
                    <Grid spacing={2} container>
                      {/* TEMPO PARA CRIAR NOVO TICKET */}
                      <Grid xs={6} md={3} item>
                        <Field
                          as={TextField}
                          label={i18n.t(
                            "whatsappModal.form.timeCreateNewTicket"
                          )}
                          fullWidth
                          name="timeCreateNewTicket"
                          variant="outlined"
                          margin="dense"
                          error={
                            touched.timeCreateNewTicket &&
                            Boolean(errors.timeCreateNewTicket)
                          }
                          helperText={
                            touched.timeCreateNewTicket &&
                            errors.timeCreateNewTicket
                          }
                        />
                      </Grid>

                      {/* QUANTIDADE MÁXIMA DE VEZES QUE O CHATBOT VAI SER ENVIADO */}
                      <Grid xs={6} md={3} item>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.maxUseBotQueues")}
                          fullWidth
                          name="maxUseBotQueues"
                          variant="outlined"
                          margin="dense"
                          error={
                            touched.maxUseBotQueues &&
                            Boolean(errors.maxUseBotQueues)
                          }
                          helperText={
                            touched.maxUseBotQueues && errors.maxUseBotQueues
                          }
                        />
                      </Grid>
                      {/* TEMPO PARA ENVIO DO CHATBOT */}
                      <Grid xs={6} md={3} item>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.timeUseBotQueues")}
                          fullWidth
                          name="timeUseBotQueues"
                          variant="outlined"
                          margin="dense"
                          error={
                            touched.timeUseBotQueues &&
                            Boolean(errors.timeUseBotQueues)
                          }
                          helperText={
                            touched.timeUseBotQueues && errors.timeUseBotQueues
                          }
                        />
                      </Grid>
                      {/* TEMPO PARA RETORNAR A FILA */}
                      <Grid xs={6} md={3} item>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.timeToReturnQueue")}
                          fullWidth
                          name="timeToReturnQueue"
                          variant="outlined"
                          margin="dense"
                          error={
                            touched.timeToReturnQueue &&
                            Boolean(errors.timeToReturnQueue)
                          }
                          helperText={
                            touched.timeToReturnQueue &&
                            errors.timeToReturnQueue
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid spacing={2} container>
                      {/* ENCERRAR CHATS ABERTOS APÓS X HORAS */}
                      <Grid xs={6} md={6} item>
                        <Field
                          as={TextField}
                          label={renderInactiveHelpLabel(
                            i18n.t("whatsappModal.form.expiresTicket")
                          )}
                          type="number"
                          fullWidth
                          name="expiresTicket"
                          required={values.timeInactiveMessage > 0}
                          variant="outlined"
                          margin="dense"
                          InputLabelProps={{ style: { pointerEvents: "auto" } }}
                          inputProps={{ min: 0, step: 1 }}
                          error={
                            touched.expiresTicket &&
                            Boolean(errors.expiresTicket)
                          }
                          helperText={
                            (touched.expiresTicket && errors.expiresTicket) ||
                            `Minimo ${MIN_EXPIRES_TICKET_MINUTES} minutos (use 0 para desativar).`
                          }
                        />
                      </Grid>
                      {/* TEMPO PARA ENVIO DO CHATBOT */}
                      <Grid xs={6} md={6} item>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          fullWidth
                        // className={classes.formControl}
                        >
                          <InputLabel id="whenExpiresTicket-selection-label">
                            {i18n.t("whatsappModal.form.whenExpiresTicket")}
                          </InputLabel>
                          <Field
                            as={Select}
                            label={i18n.t(
                              "whatsappModal.form.whenExpiresTicket"
                            )}
                            placeholder={i18n.t(
                              "whatsappModal.form.whenExpiresTicket"
                            )}
                            labelId="whenExpiresTicket-selection-label"
                            id="whenExpiresTicket"
                            name="whenExpiresTicket"
                          >
                            <MenuItem value={"0"}>
                              {i18n.t(
                                "whatsappModal.form.closeLastMessageOptions1"
                              )}
                            </MenuItem>
                            <MenuItem value={"1"}>
                              {i18n.t(
                                "whatsappModal.form.closeLastMessageOptions2"
                              )}
                            </MenuItem>
                          </Field>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Popover
                      open={inactiveHelpOpen}
                      anchorEl={inactiveHelpAnchorEl}
                      onClose={handleInactiveHelpClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "left" }}
                      PaperProps={{
                        style: {
                          maxWidth: 460,
                          padding: 14,
                          borderRadius: 8
                        }
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ color: "#d32f2f", fontWeight: 700, marginBottom: 6 }}
                      >
                        Encerramento por inatividade
                      </Typography>
                      <Typography variant="body2">
                        O aviso de inatividade e o encerramento consideram o{" "}
                        <strong>ultimo contato real (cliente/atendente)</strong>. O envio do
                        aviso <strong>nao reinicia a contagem</strong>. Com o job em ciclo de
                        5 minutos, a verificacao acontece <strong>somente de 5 em 5 minutos</strong>.
                        Por isso, o encerramento pode ocorrer no <strong>proximo ciclo</strong>.
                        Use <strong>no minimo 5 minutos</strong> (ou{" "}
                        <strong>0 para desativar</strong>) nos campos de tempo.
                      </Typography>
                    </Popover>
                    {/* MENSAGEM POR INATIVIDADE*/}
                    <div>
                      <Field
                        as={TextField}
                        label={i18n.t(
                          "whatsappModal.form.expiresInactiveMessage"
                        )}
                        multiline
                        rows={4}
                        fullWidth
                        name="expiresInactiveMessage"
                        error={
                          touched.expiresInactiveMessage &&
                          Boolean(errors.expiresInactiveMessage)
                        }
                        helperText={
                          touched.expiresInactiveMessage &&
                          errors.expiresInactiveMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                    </div>

                    {/* TEMPO PARA ENVIO DE MENSAGEM POR INATIVIDADE */}
                    <Field
                      as={TextField}
                      label={renderInactiveHelpLabel(
                        i18n.t("whatsappModal.form.timeInactiveMessage")
                      )}
                      type="number"
                      fullWidth
                      name="timeInactiveMessage"
                      variant="outlined"
                      margin="dense"
                      InputLabelProps={{ style: { pointerEvents: "auto" } }}
                      inputProps={{ min: 0, step: 1 }}
                      error={
                        touched.timeInactiveMessage &&
                        Boolean(errors.timeInactiveMessage)
                      }
                      helperText={
                        (touched.timeInactiveMessage &&
                        errors.timeInactiveMessage) ||
                        `Minimo ${MIN_INACTIVE_WARNING_MINUTES} minutos (use 0 para desativar).`
                      }
                    />
                    {/* MENSAGEM POR INATIVIDADE*/}
                    <div>
                      <Field
                        as={TextField}
                        label={i18n.t("whatsappModal.form.inactiveMessage")}
                        multiline
                        rows={4}
                        fullWidth
                        name="inactiveMessage"
                        error={
                          touched.inactiveMessage &&
                          Boolean(errors.inactiveMessage)
                        }
                        helperText={
                          touched.inactiveMessage && errors.inactiveMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                    </div>


                    <Grid spacing={2} container>
                      {user.showFlow === "enabled" && (
                        <>
                          {/* TEMPO PARA ENVIO DE MENSAGEM POR INATIVIDADE */}
                          <Grid xs={6} md={4} item>
                            <Field
                              as={TextField}
                              label={i18n.t("whatsappModal.form.flowInactiveTime")}
                              fullWidth
                              name="flowInactiveTime"
                              variant="outlined"
                              margin="dense"
                              error={
                                touched.flowIdInactiveTime &&
                                Boolean(errors.flowIdInactiveTime)
                              }
                              helperText={
                                touched.flowIdInactiveTime &&
                                errors.flowIdInactiveTime
                              }
                            />
                          </Grid>
                        </>
                      )}
                      {/* QUANTIDADE MÁXIMA DE VEZES QUE O FLOW DE INATIVIDADE VAI SER ENVIADO */}
                      <Grid xs={6} md={4} item>
                        <Field
                          as={TextField}
                          label={i18n.t(
                            "whatsappModal.form.maxUseInactiveTime"
                          )}
                          fullWidth
                          name="maxUseInactiveTime"
                          variant="outlined"
                          margin="dense"
                          error={
                            touched.maxUseInactiveTime &&
                            Boolean(errors.maxUseInactiveTime)
                          }
                          helperText={
                            touched.maxUseInactiveTime &&
                            errors.maxUseInactiveTime
                          }
                        />
                      </Grid>

                      {user.showFlow === "enabled" && (
                        <Grid xs={6} md={4} item>
                          {/* FLUXO DE INATIVIDADE */}
                          <div>
                            <FormControl
                              variant="outlined"
                              margin="dense"
                              className={classes.FormControl}
                              fullWidth
                            >
                              <Select
                                name="flowIdInactiveTime"
                                value={flowIdInactiveTime || ""}
                                onChange={handleChangeFlowIdInactiveTime}
                                id="flowIdInactiveTime"
                                variant="outlined"
                                margin="dense"
                                labelId="flowIdInactiveTime-selection-label"
                              >
                                <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                                {webhooks.map((webhook) => (
                                  <MenuItem key={webhook.id} value={webhook.id}>
                                    {webhook.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                      )}
                    </Grid>

                    {/* <Grid spacing={2} container>
                      <Grid xs={6} md={4} item>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.timeAwaitActiveFlow")}
                          fullWidth
                          name="timeAwaitActiveFlow"
                          variant="outlined"
                          margin="dense"
                          error={
                            touched.timeAwaitActiveFlow &&
                            Boolean(errors.timeAwaitActiveFlow)
                          }
                          helperText={
                            touched.timeAwaitActiveFlow &&
                            errors.timeAwaitActiveFlow
                          }
                        />
                      </Grid>

                      <Grid xs={6} md={4} item>
                        <div>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            className={classes.FormControl}
                            fullWidth
                          >
                            <Select
                              name="timeAwaitActiveFlowId"
                              value={timeAwaitActiveFlowId || ""}
                              onChange={handleChangeTimeAwaitActiveFlowId}
                              id="timeAwaitActiveFlowId"
                              variant="outlined"
                              margin="dense"
                              labelId="timeAwaitActiveFlowId-selection-label"
                            >
                              <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid> */}
                  </DialogContent>
                </TabPanel>

                {/* NPS */}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"nps"}
                >
                  <DialogContent dividers>
                    {/* MENSAGEM DE AVALIAÇAO*/}
                    <div>
                      <Field
                        as={TextField}
                        label={i18n.t("whatsappModal.form.ratingMessage")}
                        multiline
                        rows={4}
                        fullWidth
                        name="ratingMessage"
                        error={
                          touched.ratingMessage && Boolean(errors.ratingMessage)
                        }
                        helperText={
                          touched.ratingMessage && errors.ratingMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                    </div>
                    {/* QUANTIDADE MÁXIMA DE VEZES QUE O NPS VAI SER ENVIADO */}
                    <div>
                      <Field
                        as={TextField}
                        label={i18n.t("whatsappModal.form.maxUseBotQueuesNPS")}
                        fullWidth
                        name="maxUseBotQueuesNPS"
                        variant="outlined"
                        margin="dense"
                        error={
                          touched.maxUseBotQueuesNPS &&
                          Boolean(errors.maxUseBotQueuesNPS)
                        }
                        helperText={
                          touched.maxUseBotQueuesNPS &&
                          errors.maxUseBotQueuesNPS
                        }
                      />
                    </div>
                    {/* ENCERRAR CHATS NPS APÓS X Minutos */}
                    <div>
                      <Field
                        as={TextField}
                        label={i18n.t("whatsappModal.form.expiresTicketNPS")}
                        fullWidth
                        name="expiresTicketNPS"
                        variant="outlined"
                        margin="dense"
                        error={
                          touched.expiresTicketNPS &&
                          Boolean(errors.expiresTicketNPS)
                        }
                        helperText={
                          touched.expiresTicketNPS && errors.expiresTicketNPS
                        }
                      />
                    </div>
                  </DialogContent>
                </TabPanel>

                {/* Flowbuilder */}
                {showIntegrations && user.showFlow === "enabled" && (
                  <>
                    <TabPanel
                      className={classes.container}
                      value={tab}
                      name={"flowbuilder"}
                    >
                      <DialogContent>
                        <h3>Fluxo de boas vindas</h3>
                        <p>
                          Este fluxo é disparado apenas para novos contatos,
                          pessoas que voce não possui em sua lista de contatos e
                          que mandaram uma mensagem
                        </p>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          className={classes.FormControl}
                          fullWidth
                        >
                          <Select
                            name="flowIdNotPhrase"
                            value={flowIdNotPhrase || ""}
                            onChange={handleChangeFlowIdNotPhrase}
                            id="flowIdNotPhrase"
                            variant="outlined"
                            margin="dense"
                            labelId="flowIdNotPhrase-selection-label"
                          >
                            <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                            {webhooks.map((webhook) => (
                              <MenuItem key={webhook.id} value={webhook.id}>
                                {webhook.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </DialogContent>
                      <DialogContent>
                        <h3>Fluxo de resposta padrão</h3>
                        <p>
                          Resposta Padrão é enviada com qualquer caractere
                          diferente de uma palavra chave. ATENÇÃO! Será
                          disparada se o atendimento ja estiver fechado.
                        </p>
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          className={classes.FormControl}
                          fullWidth
                        >
                          <Select
                            name="flowIdWelcome"
                            value={flowIdWelcome || ""}
                            onChange={handleChangeFlowIdWelcome}
                            id="flowIdWelcome"
                            variant="outlined"
                            margin="dense"
                            labelId="flowIdWelcome-selection-label"
                          >
                            <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                            {webhooks.map((webhook) => (
                              <MenuItem key={webhook.id} value={webhook.id}>
                                {webhook.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </DialogContent>
                    </TabPanel>
                  </>
                )}

                {/* Schedules */}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"schedules"}
                >
                  {tab === "schedules" && (
                    <Paper style={{ padding: 20 }}>
                      <SchedulesForm
                        loading={false}
                        onSubmit={handleSaveSchedules}
                        initialValues={schedules}
                        labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
                      />
                    </Paper>
                  )}
                </TabPanel>

                {/* WebChat Widget Code */}
                {channel === "webchat" && (
                  <TabPanel
                    className={classes.container}
                    value={tab}
                    name={"widget"}
                  >
                    <DialogContent dividers>
                      <WebchatConnectionSwitch
                        channel={channel}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                      <Typography variant="h6" gutterBottom>
                        Código para adicionar ao seu site
                      </Typography>
                      <Typography variant="body2" color="textSecondary" paragraph>
                        Copie o código abaixo e cole antes do fechamento da tag &lt;/body&gt; do seu site HTML.
                      </Typography>
                      
                      <TextField
                        fullWidth
                        multiline
                        rows={15}
                        value={webchatCode}
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleCopyWebChatCode}
                                edge="end"
                                aria-label="copiar código"
                              >
                                <FileCopy />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        style={{
                          fontFamily: "monospace",
                          fontSize: "12px",
                          marginTop: 16,
                        }}
                      />
                      
                      {copied && (
                        <Typography
                          variant="body2"
                          color="primary"
                          style={{ marginTop: 8 }}
                        >
                          ✓ Código copiado para a área de transferência!
                        </Typography>
                      )}

                      <Box mt={3}>
                        <Typography variant="subtitle2" gutterBottom>
                          Instruções:
                        </Typography>
                        <Typography variant="body2" component="div">
                          <ol>
                            <li>Copie o código acima</li>
                            <li>Cole no final do seu HTML, antes de &lt;/body&gt;</li>
                            <li>O widget aparecerá automaticamente no seu site</li>
                            <li>Os visitantes poderão iniciar conversas diretamente</li>
                          </ol>
                        </Typography>
                      </Box>

                      <Divider style={{ marginTop: 24, marginBottom: 16 }} />

                      {webchatDiag && (
                        <Box
                          style={{
                            marginBottom: 16,
                            padding: 12,
                            borderRadius: 8,
                            border: `1px solid ${webchatDiag.pronto ? "#1a8b4a" : "#8a5a00"}`,
                            background: webchatDiag.pronto ? "rgba(26,139,74,.08)" : "rgba(138,90,0,.08)"
                          }}
                        >
                          <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                            {webchatDiag.pronto
                              ? "✅ Pronto para usar"
                              : "⚠️ Falta configurar para funcionar por completo"}
                          </Typography>
                          <Typography variant="body2" color="textSecondary" component="div" style={{ marginTop: 6 }}>
                            <div>{webchatDiag.chatLigado ? "✓" : "✗"} Chat ligado (salvo nesta conexão)</div>
                            <div>
                              {Array.isArray(webchatDiag.conexoesComConvite) && webchatDiag.conexoesComConvite.length > 0
                                ? `✓ Convite saindo por: ${webchatDiag.conexoesComConvite.join(", ")}`
                                : "✗ Nenhuma conexão de WhatsApp convidando clientes"}
                            </div>
                            <div>{webchatDiag.notificacoes ? "✓" : "✗"} Aviso no celular do cliente (notificação)</div>
                            <div>{webchatDiag.linkAssinado ? "✓" : "✗"} Link identificado do cliente</div>
                            <div>{webchatDiag.enderecoApp ? "✓" : "✗"} Endereço do aplicativo</div>
                            <div>
                              {webchatDiag.setor ? "✓" : "✗"} Setor do atendimento
                              {webchatDiag.setor ? `: ${webchatDiag.setor}` : " (nenhum ligado nesta conexão)"}
                            </div>
                          </Typography>
                          {Array.isArray(webchatDiag.avisos) && webchatDiag.avisos.length > 0 && (
                            <Typography variant="body2" component="ul" style={{ marginTop: 8, paddingLeft: 18 }}>
                              {webchatDiag.avisos.map((aviso, i) => (
                                <li key={i} style={{ marginBottom: 4 }}>{aviso}</li>
                              ))}
                            </Typography>
                          )}
                          <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>
                            <strong>Como o cliente chega aqui:</strong> em Conexões, abra a conexão de
                            WhatsApp e ligue <em>"Convidar clientes desta conexão para o chat próprio"</em>.
                            O convite entra na saudação com o link pessoal de cada cliente, já identificado
                            — e a partir daí ele conversa por aqui, sem custo de Meta. Para parar tudo,
                            desligue a chave <em>"Chat ligado"</em> acima.
                          </Typography>
                        </Box>
                      )}

                      <Typography variant="subtitle1" gutterBottom>
                        Aplicativo do cliente (Gallera Chat)
                      </Typography>
                      <Typography variant="body2" color="textSecondary" paragraph>
                        Endereço base do aplicativo do cliente. Para chamar um
                        cliente específico, use o botão <strong>&quot;Enviar link do
                        aplicativo&quot;</strong> na tela de Contatos — lá o link já vai
                        identificado (nome, ícone e cor da empresa vêm junto), sem o
                        cliente precisar digitar nada.
                      </Typography>
                      <TextField
                        fullWidth
                        value={webchatPwaUrl}
                        variant="outlined"
                        size="small"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title="Copiar link do aplicativo">
                                <IconButton
                                  onClick={handleCopyWebchatPwaUrl}
                                  edge="end"
                                  aria-label="copiar link do aplicativo"
                                  size="small"
                                >
                                  <FileCopy fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        style={{ fontFamily: "monospace", fontSize: "12px" }}
                      />

                      <Divider style={{ marginTop: 24, marginBottom: 16 }} />

                      <Typography variant="subtitle1" gutterBottom>
                        Domínios autorizados (site onde o widget corre)
                      </Typography>
                      <Typography variant="body2" color="textSecondary" paragraph>
                        Se a lista estiver <strong>vazia</strong> e guardar, o widget funciona em <strong>qualquer</strong> site.
                        Se adicionar domínios e guardar, só esses sites (e subdomínios) poderão abrir conversas — útil para segurança.
                      </Typography>
                      <div className={classes.multFieldLine} style={{ alignItems: "flex-start", flexWrap: "wrap" }}>
                        <TextField
                          className={classes.textField}
                          label="Domínio ou URL"
                          placeholder="ex.: minhaloja.com.br ou https://www.minhaloja.com.br"
                          variant="outlined"
                          size="small"
                          value={webchatDomainInput}
                          onChange={(e) => setWebchatDomainInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleAddWebchatDomain();
                            }
                          }}
                        />
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleAddWebchatDomain}
                        >
                          Adicionar
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={savingWebchatDomains}
                          onClick={handleSaveWebchatDomains}
                        >
                          {savingWebchatDomains ? (
                            <CircularProgress size={22} color="inherit" />
                          ) : (
                            "Guardar domínios"
                          )}
                        </Button>
                      </div>
                      <Box mt={1} display="flex" flexWrap="wrap" style={{ gap: 8 }}>
                        {webchatAllowedDomains.map((d) => (
                          <Chip
                            key={d}
                            label={d}
                            onDelete={() => handleRemoveWebchatDomain(d)}
                            size="small"
                          />
                        ))}
                      </Box>
                    </DialogContent>
                  </TabPanel>
                )}
              </Paper>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("whatsappModal.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {whatsAppId
                    ? i18n.t("whatsappModal.buttons.okEdit")
                    : i18n.t("whatsappModal.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div >
  );
};

export default React.memo(WhatsAppModal);
